import { useEffect } from 'react'
import { gsap } from 'gsap'

export function useCustomizationShowAnimation({ index = 0, ...refs }) {
  useEffect(() => {
    const ctx = gsap.context(() => {
      const item = refs.itemRef?.current
      const image = refs.imageRef?.current
      const title = refs.titleRef?.current
      const bannerTitle = refs.bannerTitleRef?.current

      if (!item) return

      const showTimeline = gsap.timeline({ delay: index * 0.1 })

      showTimeline
        .set(item, { scaleX: 0, scaleY: 0, opacity: 1 })
        .to(item, { scaleX: 1, scaleY: 0.05, duration: 0.5 })
        .to(item, { scaleX: 1, scaleY: 1, duration: 0.5 })

      if (image) {
        showTimeline.from(
          image,
          {
            scale: 0.3,
            opacity: 0,
            duration: 0.5,
            ease: 'elastic.out(1, 0.5)',
          },
          '-=0.4',
        )
      }

      if (title) {
        showTimeline.from(
          title,
          {
            xPercent: -50,
            scale: 0.3,
            opacity: 0,
            duration: 0.5,
            ease: 'elastic.out(1, 0.5)',
            clearProps: 'transform',
          },
          '-=0.35',
        )
      }

      if (bannerTitle) {
        showTimeline.from(
          bannerTitle,
          {
            xPercent: -50,
            scale: 0.2,
            opacity: 0,
            duration: 0.5,
            ease: 'elastic.out(1, 0.5)',
            clearProps: 'transform',
          },
          '-=0.6',
        )
      }
    }, refs.itemRef ?? undefined)

    return () => {
      ctx.revert()
    }
  }, [index, refs.itemRef, refs.imageRef, refs.titleRef, refs.bannerTitleRef])
}
